/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Key, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import downarrow from '../../assets/icons/LayoutIcons/down-arrow.svg';
import DropDownItem from './DropDownItem';

const SidebarItem = (props: any) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const handleCloseLink = (e: any) => {
    e.preventDefault();

    setOpen(false);
  };

  const handleOpenLink = (e: any) => {
    e.preventDefault();
    if (props.item.childrens) {
      const firstLink = props.item?.childrens[0]?.href;
      navigate(firstLink);
    }
    setOpen(true);
  };
  if (props.item.childrens) {
    return (
      <div
        className={` mx-[12px]
          ${open ? ' nav-bar__item  open' : 'nav-bar__item  mb-[10px] nav__links-color'}   ${
          props.item.disabled && 'disabled'
        }`}
      >
        <div
          className={` ${
            open && '!bg-[#F8B40026]'
          } flex py-[15px]  pl-[12px] sidebar-title justify-between cursor-pointer items-center font-normal text-black text-[16px]`}
          onClick={!open ? handleOpenLink : handleCloseLink}
        >
          <span className='px-3 text-black text-[16px] font-poppins '>
            <img
              src={props.item.icon}
              alt={props.item.icon}
              className='group-hover:invert-[25%] mr-4 group-hover:sepia-[49%] w-6  group-hover:saturate-[527%] group-hover:hue-rotate-[137deg] group-hover:brightness-[93%]'
            />
            {props.item.title}
          </span>
          <img src={downarrow} className='toggle-btn w-[8.1px] mr-3 ' />
        </div>

        <div className='sidebar-content' style={{ marginBottom: '30px' }}>
          {props.item.childrens.map((child: any, index: Key | null | undefined) => (
            <DropDownItem key={index} item={child} href={child.href} open={open} />
          ))}
        </div>
        {/* {props.item.title === 'Settings' ? (
          <div className='border-0'></div>
        ) : (
          <div className='border-b-[1px] mx-3  border-[#7683968f]  '></div>
        )} */}
      </div>
    );
  } else {
    return (
      <Link
        className={props.item.disabled ? `cursor-not-allowed` : `cursor-pointer `}
        to={props.item.href || location.pathname}
      >
        <div className='px-[12px] mb-[10px]'>
          <div
            className={`flex pl-[30px]  py-[15px] justify-between ${
              location.pathname.includes(props.item.href)
                ? 'bg-[#F8B40026] inline-block w-full '
                : 'nav__links-color'
            } ${props.item.disabled && 'disabled'}`}
          >
            {props.item.icon && (
              <img
                src={props.item.icon}
                alt={props.item.icon}
                width='16'
                height='16'
                className='group-hover:invert-[25%] mr-4 group-hover:sepia-[49%]   group-hover:saturate-[527%] group-hover:hue-rotate-[137deg] group-hover:brightness-[93%]'
              />
            )}

            <span
              className={`leading-[29px]  flex-1
                      nav-hover ${location.pathname.includes(props.item.href) ? 'active' : ''}
                      font-normal text-black text-[16px] font-poppins flex items-center justify-between `}
            >
              {props.item.title}
            </span>
          </div>

          {/* <div className='border-b-[1px]  border-[#7683968f]'></div> */}
        </div>
      </Link>
    );
  }
};

export default SidebarItem;
